<template>
  <div>LiningSidebar</div>
</template>

<script>
export default {
  name: 'LiningSidebar'
};
</script>

<style scoped>

</style>
